var map = {
	"./10/cover.camera.react.svg": 74760,
	"./12/alert.react.svg": 35034,
	"./12/arrow.right.svg": 61705,
	"./12/cross.react.svg": 16398,
	"./12/custom-filter.react.svg": 77358,
	"./12/folder.svg": 52452,
	"./12/link.svg": 63258,
	"./12/lock.react.svg": 24641,
	"./12/locked.react.svg": 7555,
	"./12/mail.svg": 27018,
	"./12/mute.react.svg": 55977,
	"./12/pen-edit.react.svg": 6067,
	"./12/person.svg": 45182,
	"./12/planet.react.svg": 89646,
	"./12/plus.svg": 77108,
	"./12/refresh.react.svg": 15096,
	"./12/right-arrow.react.svg": 29429,
	"./12/tick.react.svg": 45283,
	"./16/backup.svg": 83988,
	"./16/button.minus.react.svg": 34882,
	"./16/button.plus.react.svg": 99167,
	"./16/catalog-settings-common.svg": 42712,
	"./16/catalog-settings-data-management.svg": 50544,
	"./16/catalog-settings-integration.svg": 74274,
	"./16/catalog-settings-payment.svg": 75211,
	"./16/catalog-settings-restore.svg": 93814,
	"./16/catalog-settings-security.svg": 41190,
	"./16/catalog-settings-services.svg": 67823,
	"./16/catalog-settings-storage-management.svg": 44541,
	"./16/catalog.accounts.react.svg": 95221,
	"./16/catalog.archive.react.svg": 91933,
	"./16/catalog.developer.react.svg": 2316,
	"./16/catalog.documents.react.svg": 80148,
	"./16/catalog.favorites.react.svg": 33125,
	"./16/catalog.folder.react.svg": 74635,
	"./16/catalog.import.react.svg": 56825,
	"./16/catalog.old.share.react.svg": 46814,
	"./16/catalog.portfolio.react.svg": 50699,
	"./16/catalog.private.react.svg": 30146,
	"./16/catalog.projects.react.svg": 60386,
	"./16/catalog.question.react.svg": 91286,
	"./16/catalog.recent.react.svg": 12230,
	"./16/catalog.rooms.react.svg": 63562,
	"./16/catalog.settings.react.svg": 62803,
	"./16/catalog.share.small.react.svg": 79413,
	"./16/catalog.shared.react.svg": 62049,
	"./16/catalog.spam.react.svg": 10824,
	"./16/catalog.trash.react.svg": 37283,
	"./16/catalog.user.react.svg": 30184,
	"./16/catalog.user.solid.react.svg": 70195,
	"./16/check.round.react.svg": 61344,
	"./16/circle.cross.svg": 49842,
	"./16/clear.react.svg": 62905,
	"./16/copy.react.svg": 2034,
	"./16/cross.react.svg": 55922,
	"./16/custom-filter.react.svg": 77729,
	"./16/delete-permanently.react.svg": 46995,
	"./16/downgrade.react.svg": 54743,
	"./16/download.react.svg": 87490,
	"./16/duplicate.react.svg": 92051,
	"./16/export-index.react.svg": 73524,
	"./16/export-room-index.react.svg": 13838,
	"./16/horizontal-dots.react.svg": 8649,
	"./16/locked.react.svg": 97644,
	"./16/mark-as-read.react.svg": 15438,
	"./16/move.react.svg": 48092,
	"./16/mute.react.svg": 80355,
	"./16/other-operations.react.svg": 52942,
	"./16/plus.svg": 38162,
	"./16/protected.react.svg": 67632,
	"./16/refresh.react.svg": 95455,
	"./16/shared.link.svg": 9418,
	"./16/top-arrow.react.svg": 77817,
	"./16/trash.react.svg": 23093,
	"./16/upgrade.react.svg": 64402,
	"./16/upload.react.svg": 41796,
	"./16/vertical-dots.react.svg": 58550,
	"./16/wallet.react.svg": 16935,
	"./17/clear.react.svg": 8553,
	"./17/cross.react.svg": 77019,
	"./17/plus.svg": 78475,
	"./17/vertical-dots.react.svg": 99201,
	"./20/catalog-settings-common.svg": 6345,
	"./20/catalog-settings-data-management.svg": 81151,
	"./20/catalog-settings-developer.svg": 52627,
	"./20/catalog-settings-gift.svg": 27356,
	"./20/catalog-settings-import.svg": 72428,
	"./20/catalog-settings-integration.svg": 11000,
	"./20/catalog-settings-payment.svg": 45553,
	"./20/catalog-settings-restore.svg": 60123,
	"./20/catalog-settings-security.svg": 90696,
	"./20/catalog-settings-services.svg": 21716,
	"./20/catalog-settings-storage-management.svg": 56892,
	"./20/catalog.accounts.react.svg": 9220,
	"./20/catalog.archive.react.svg": 23257,
	"./20/catalog.documents.react.svg": 15244,
	"./20/catalog.favorites.react.svg": 38433,
	"./20/catalog.folder.react.svg": 40004,
	"./20/catalog.portfolio.react.svg": 48777,
	"./20/catalog.private.react.svg": 26331,
	"./20/catalog.recent.react.svg": 2222,
	"./20/catalog.rooms.react.svg": 53052,
	"./20/catalog.shared.react.svg": 64966,
	"./20/catalog.trash.react.svg": 71661,
	"./20/catalog.user.react.svg": 62228,
	"./24/archive.svg": 23314,
	"./24/backup.react.svg": 37195,
	"./24/calendar.svg": 31648,
	"./24/cell.svg": 12820,
	"./24/cellCommon.svg": 93448,
	"./24/copy.react.svg": 60039,
	"./24/delete-permanently.react.svg": 45263,
	"./24/diagram.svg": 19249,
	"./24/download.react.svg": 26631,
	"./24/duplicate.react.svg": 53,
	"./24/ebook.svg": 6768,
	"./24/export-room-index.react.svg": 85118,
	"./24/file.react.svg": 207,
	"./24/file.svg": 75140,
	"./24/folder.svg": 7118,
	"./24/folderComplete.svg": 15938,
	"./24/folderInProgress.svg": 80422,
	"./24/form.svg": 31518,
	"./24/html.svg": 7899,
	"./24/image.svg": 90196,
	"./24/letter.svg": 7624,
	"./24/mark-as-read.react.svg": 12958,
	"./24/move.react.svg": 78007,
	"./24/pdf.svg": 2035,
	"./24/planet.react.svg": 94051,
	"./24/shared.svg": 9823,
	"./24/slide.svg": 16777,
	"./24/slideCommon.svg": 72993,
	"./24/sound.svg": 73633,
	"./24/text.svg": 12577,
	"./24/trash.react.svg": 59661,
	"./24/upload.react.svg": 94403,
	"./24/video.svg": 12273,
	"./24/word.svg": 95403,
	"./24/wordCommon.svg": 91587,
	"./32/archive.svg": 21282,
	"./32/calendar.svg": 3255,
	"./32/cell.svg": 68598,
	"./32/cellCommon.svg": 45094,
	"./32/diagram.svg": 28733,
	"./32/ebook.svg": 2099,
	"./32/file.svg": 52152,
	"./32/fill.out.yourself.svg": 53912,
	"./32/folder.svg": 28322,
	"./32/folderComplete.svg": 4544,
	"./32/folderInProgress.svg": 54173,
	"./32/form.data.collection.svg": 1844,
	"./32/form.svg": 76049,
	"./32/html.svg": 55279,
	"./32/image.svg": 99531,
	"./32/letter.svg": 41772,
	"./32/pdf.svg": 43228,
	"./32/role.based.filling.svg": 47676,
	"./32/room/ai.svg": 76280,
	"./32/room/archive.svg": 29247,
	"./32/room/custom.svg": 30908,
	"./32/room/editing.svg": 50595,
	"./32/room/form.svg": 22161,
	"./32/room/public.svg": 81776,
	"./32/room/template.svg": 23076,
	"./32/room/virtual-data.svg": 57920,
	"./32/share.svg": 27534,
	"./32/slide.svg": 3847,
	"./32/slideCommon.svg": 19011,
	"./32/sound.svg": 64616,
	"./32/template/collaboration.svg": 61664,
	"./32/template/custom.svg": 54199,
	"./32/template/form.svg": 63038,
	"./32/template/public.svg": 15132,
	"./32/template/virtual-data.svg": 95966,
	"./32/text.svg": 36719,
	"./32/video.svg": 85977,
	"./32/word.svg": 73280,
	"./32/wordCommon.svg": 17582,
	"./64/archive.svg": 7826,
	"./64/calendar.svg": 37225,
	"./64/cell.svg": 31120,
	"./64/cellCommon.svg": 33384,
	"./64/diagram.svg": 49398,
	"./64/ebook.svg": 89366,
	"./64/file.svg": 6279,
	"./64/folder.svg": 54291,
	"./64/folderComplete.svg": 33362,
	"./64/folderInProgress.svg": 40140,
	"./64/form.svg": 714,
	"./64/html.svg": 50709,
	"./64/image.svg": 36965,
	"./64/letter.svg": 78062,
	"./64/pdf.svg": 85978,
	"./64/slide.svg": 95071,
	"./64/slideCommon.svg": 58701,
	"./64/sound.svg": 91291,
	"./64/text.svg": 44005,
	"./64/video.svg": 23448,
	"./64/word.svg": 56905,
	"./64/wordCommon.svg": 28622,
	"./96/archive.svg": 38537,
	"./96/calendar.svg": 23804,
	"./96/cell.svg": 5372,
	"./96/cellCommon.svg": 70442,
	"./96/diagram.svg": 98197,
	"./96/ebook.svg": 743,
	"./96/file.svg": 12880,
	"./96/folder.svg": 52931,
	"./96/folderComplete.svg": 7236,
	"./96/folderInProgress.svg": 13660,
	"./96/form.svg": 8297,
	"./96/html.svg": 38313,
	"./96/image.svg": 4426,
	"./96/letter.svg": 34372,
	"./96/pdf.svg": 72303,
	"./96/slide.svg": 33652,
	"./96/slideCommon.svg": 46744,
	"./96/sound.svg": 41943,
	"./96/text.svg": 27844,
	"./96/video.svg": 65417,
	"./96/word.svg": 2584,
	"./96/wordCommon.svg": 81744
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83392;